import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useGetSalesHistoryQuery } from 'services/api/sales';
import { selectTabFilters } from 'services/salesHistorySlice/salesHistorySlice';
import { useDeviceInfo } from 'hooks/useDeviceInfo';
import TransactionRecordCard from './TransactionRecordCard';
import MobileTransactionCard from './MobileTransactionCard';

const TAB_FILTERS: Record<string, Record<string, string>> = {
  sold: { status: 'awarded' },
  waiting_on_title: { title_status: 'waiting_on_title' },
};

const HistoryPage = ({ page, tabKey }: { page: number; tabKey: string }) => {
  const { perPage } = useSelector((state: any) => state.salesHistory);
  const filters = useSelector((state: any) => selectTabFilters(state, tabKey));
  const tabFilters = TAB_FILTERS[tabKey] ?? {};
  const { data } = useGetSalesHistoryQuery({ limit: perPage, offset: page, ...filters, ...tabFilters });
  const { isMobile } = useDeviceInfo();

  const vehicles = useMemo(() => data?.rows?.ids?.map((id: any) => data?.rows?.entities?.[id]) ?? [], [data]);

  const CardComponent = isMobile ? MobileTransactionCard : TransactionRecordCard;

  return (
    <>
      {vehicles.map((vehicle: any) => (
        <CardComponent key={vehicle.id} vehicle={vehicle} />
      ))}
    </>
  );
};

export default HistoryPage;
